class KovForm {
  constructor($scope) {
    'ngInject';
    this.$scope = $scope;
    //this.sName = initialState;
    //console.log('hallo', this.sName);
  }

  $onInit() {
    this.sName = {
      formGroups: {},
      errorCount: 0,
      valid: true
    };
    /* this.$scope.$on('resetFormValidation', () => {
      this.sName = {
        formGroups: Object.fromEntries(Object.entries(this.sName.formGroups).map(([key]) => ([key, { errors: [], valid: true }]))),
        errorCount: 0,
        valid: true
      };
    }); */
    this.$scope.$on('onErrorsChanged', (event, payload) => {
      //console.log('onErrorsChanged event', payload)
      this.sName.formGroups[payload.key] = {
        errors: payload.errors,
        valid: payload.errors.length === 0
      };
      let count = 0;
      Object.keys(this.sName.formGroups).forEach(key => {
        count += this.sName.formGroups[key].errors.length;
      });
      this.sName.errorCount = count;
      this.sName.valid = count === 0;
      this.$scope.$emit('onFormValidationChanged', this.sName);
      event.stopPropagation();
    });
  }
}

module.exports = {
  template: require('./kovForm.html'),
  controllerAs: 'ctrl',
  controller: KovForm,
  transclude: true,
  bindings: {
    sName: '='
  }
};
